import { Component, For, createEffect, on } from 'solid-js'
import { StateMapDisk } from '../lib/core/state/state_map_disk.enum'
import { hasCloud } from '../lib/core/has_cloud'
import { hasIndexedDB } from '../lib/core/Storage/IndexedDB/hasIndexedDB'

interface Props {
  id?: string
  value: StateMapDisk
  onChange: (value: StateMapDisk) => void
  localStorageKey?: string
}

const DiskSelect: Component<Props> = (props) => {
  const hasIndexedDBFeature = hasIndexedDB()
  const disks = [
    ...(hasCloud ? [{ label: 'Cloud', value: StateMapDisk.Cloud }] : []),
    ...(hasIndexedDBFeature ? [{ label: 'IndexedDB (Offline)', value: StateMapDisk.IndexedDB }] : []),
  ]
  if (!disks.length) {
    throw new Error('No supported disks available (IndexedDB or Cloud required)')
  }

  createEffect(on(() => props.value, (val) => {
    if (props.localStorageKey) {
      localStorage.setItem(props.localStorageKey, val)
    }
  }))

  return (
    <div class="mb-3 d-flex align-items-center">
      <label class="me-2" for={props.id}>Storage:</label>
      {disks.length > 1 ? (
        <select
          id={props.id}
          class="form-select form-select-sm w-auto"
          value={props.value}
          onChange={(e) => props.onChange(e.currentTarget.value as StateMapDisk)}
        >
          <For each={disks}>
            {(disk) => <option value={disk.value}>{disk.label}</option>}
          </For>
        </select>
      ) : (
        <span class="text-muted">{disks[0].label}</span>
      )}
    </div>
  )
}

export default DiskSelect
